exports.keysplit = require('./keysplit');

/**
 * Tests if an object is reasonably a Stream object... Not perfect, but should be
 * good enough.
 *
 * This method is a bit unreliable and may need to be updated from time to time
 * if it doesn't work...  This broke recently on us when webpack changed their
 * NodeJS shim object hierarchy to not have {Stream} as the root...
 *
 * @param {*} obj - The object to test.
 * @returns {boolean} - True if it is a {Stream} like object.
 */
function isStream(obj) {
  const stream = require('stream');

  // Do an instanceof check as a shortcut, this should work from node
  const isInstanceOfStream = obj instanceof stream.Stream;

  // Additionally test the object structure and if it has a pipe function, this should work
  // in the browser.
  return isInstanceOfStream || (typeof obj === 'object' && typeof obj.pipe === 'function');
}

function base64ToBuffer(b64) {
  return inBrowser() && window.atob
    ? Uint8Array.from(atob(b64), (c) => c.charCodeAt(0))
    : new Buffer(b64, 'base64');
}

function arrayBufferToBuffer(ab) {
  const buf = Buffer.alloc(ab.byteLength);
  const view = new Uint8Array(ab);
  for (let i = 0; i < buf.length; ++i) {
    buf[i] = view[i];
  }
  return buf;
}

function bufferToArrayBuffer(buf) {
  const ab = new ArrayBuffer(buf.length);
  const view = new Uint8Array(ab);
  for (let i = 0; i < buf.length; ++i) {
    view[i] = buf[i];
  }
  return ab;
}

async function streamToBuffer(stream) {
  const bufs = [];
  stream.on('data', function (d) {
    bufs.push(d);
  });
  return new Promise((resolve) => {
    stream.on('end', function () {
      resolve(Buffer.concat(bufs));
    });
  });
}

async function streamToString(stream, encoding) {
  return (await streamToBuffer(stream)).toString(encoding || 'utf8');
}

function inBrowser() {
  return typeof window !== 'undefined';
}

exports.isStream = isStream;
exports.base64ToBuffer = base64ToBuffer;
exports.inBrowser = inBrowser;
exports.arrayBufferToBuffer = arrayBufferToBuffer;
exports.bufferToArrayBuffer = bufferToArrayBuffer;
exports.streamToBuffer = streamToBuffer;
exports.streamToString = streamToString;
